import type { ReactNode } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { Container, type ITimeMachine, Jumbo } from '@treams/treams-ui';

import type { GroupSelectionData } from '../goals/group-selector/new/useGroupSelection';
import { AnalyticsMetrics } from './AnalyticsMetrics';
import AnalyticsUserFilterSelector from './AnalyticsUserFilterSelector';
import { AnalyticsFilter } from './components/AnalyticsFilter';

type AnalyticsViewProps = {
	groupSelectionFilter: (group: graphql.Group) => boolean;
	headerButton?: ReactNode;
	headerFooter?: ReactNode;
	timeMachine: ITimeMachine;
	onChangeTimeMachine: (newTimeMachine: ITimeMachine) => void;
	groupSelection: GroupSelectionData;
	loading: boolean;
	engagementOfficerMetricsOnly: boolean;
};

export function AnalyticsView(props: AnalyticsViewProps) {
	const { t } = useTranslation();

	const [userFilter, setUserFilter] = useState<graphql.AnalyticsUserFilter | undefined>(
		graphql.AnalyticsUserFilter.ActiveAtEndDate,
	);

	return (
		<>
			<Jumbo
				title={t('analytics.overview.title')}
				footer={props.headerFooter}
				button={props.headerButton}
				inlineButton
				wide={true}
			/>
			<AnalyticsFilter
				departments={props.groupSelection}
				departmentsLoading={props.loading}
				canSelectGroup={props.groupSelectionFilter}
				onDepartmentChange={props.groupSelection.updateExplicitGroupSelection}
				timeMachine={props.timeMachine}
				onTimeMachineChange={props.onChangeTimeMachine}
				timePeriodAccessory={<AnalyticsUserFilterSelector onChange={setUserFilter} />}
			/>
			<Container py={4} wide={true}>
				{!props.loading && (
					<AnalyticsMetrics
						timeMachine={props.timeMachine}
						groups={props.groupSelection.groupsInSelection}
						hasExplicitGroupSelection={props.groupSelection.hasExplicitGroupSelection}
						userFilter={userFilter}
						engagementOfficerMetricsOnly={props.engagementOfficerMetricsOnly}
					/>
				)}
			</Container>
		</>
	);
}
